import { useLang } from '@/app/utils/useLang';
import VideoSection from '../Common/VideoSection';
import styles from './index.module.scss';

interface CoverSection2Props {
    maskEnhance?: boolean; // 是否加强蒙层
}

const CoverSection2: React.FC<CoverSection2Props> = ({ maskEnhance = false }) => {
    const { t } = useLang('CoverSection2');

    return (
        <div className={`page-coverSection2 ${styles.CoverSection2} GtmModuleData-section`} id="videoSection2" data-section-id="d3m-video-section2">
            <VideoSection
                sectionId="videoSection2"
                triggerSelector="#videoSection2"
                videoSrc="https://websiteoss.ecoflow.com/upload/video/1759041363378/2-02.mp4"
                posterSrc="https://websiteoss.ecoflow.com/figma-uploads/1758871205734-a9xrmm-compressed-2.jpg"
                label={t('label')}
                title={t.rich('title', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
                maskEnhance={maskEnhance}
                desc={t('desc')}
            />
        </div>
    );
};

export default CoverSection2;
